import React, { Component } from 'react';
import ValidationSection from './validation_section';
import ValidationError from './validation_error';
import I18n from '~/utils/translations';
import { default as ReactSelect } from 'react-select';

export default class Select extends Component {
  render() {
    const { errors, className, ...others } = this.props;
    return (
      <ValidationSection className={`select ${className}`} errors={errors}>
        <label>
          <div className="select__text-container">
            {this.props.label}
            {this.hint && <span className="input-hint">{this.hint}</span>}
          </div>
          <div className="select__field-wrapper">
            <ReactSelect
              {...others}
              classNamePrefix="select"
              theme={(theme) => ({ colors: {}, spacing: {} })} // Disable react-select default theme styles
            />
          </div>
          <ValidationError version="2" errors={errors} />
        </label>
      </ValidationSection>
    );
  }

  get hint() {
    if (!!this.props.hint) {
      return this.props.hint;
    }
    if (this.props.optional) {
      return I18n.t('optional_input');
    }
    return null;
  }
}
